import _ from "lodash";

export const getEnabledKeys = items => _.map(items || [], "id");

export const buildNewColumnItem = ({
  id,
  label: labelText,
  description,
  isManageColumnItem = false,
}) => ({
  id,
  content: labelText || id,
  label: {
    defaultValue: labelText || id,
  },
  isEnabled: true,
  isCheckable: true,
  isLabelEditable: true,
  isManageColumnItem,
  description: description || "",
});
